export default {
  state: {
    isInternetAvailable: true
  }
}
